import { render, staticRenderFns } from "./StudentQrCodeDialog.vue?vue&type=template&id=764b1b10&scoped=true"
import script from "./StudentQrCodeDialog.vue?vue&type=script&lang=js"
export * from "./StudentQrCodeDialog.vue?vue&type=script&lang=js"
import style0 from "./StudentQrCodeDialog.vue?vue&type=style&index=0&id=764b1b10&prod&scoped=true&lang=css"
import style1 from "./StudentQrCodeDialog.vue?vue&type=style&index=1&id=764b1b10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b1b10",
  null
  
)

export default component.exports